import { colors, TableRow } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableRowStyled = styled(TableRow)`
  background-color: ${colors.neutral.white};
  margin-bottom: 0.8rem;
  border-radius: 6px;
  position: relative;
`;
